import { Loader2, ShieldOff, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

export default function SenderRulesDialog({ open, onOpenChange, rules, loading, onRemove }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" closeTestId="close-sender-rules-icon-button" data-testid="sender-rules-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight">Always-skip senders</DialogTitle>
          <DialogDescription>Exact addresses only. Removing a rule affects future emails and does not restore older skipped messages.</DialogDescription>
        </DialogHeader>
        <div className="max-h-80 overflow-y-auto border-y border-border divide-y divide-border" data-testid="sender-rules-list">
          {loading ? (
            <div className="py-12 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>
          ) : rules.length === 0 ? (
            <div className="py-12 text-center" data-testid="sender-rules-empty-state">
              <ShieldOff className="w-7 h-7 mx-auto text-muted-foreground mb-2" />
              <p className="text-sm text-muted-foreground">No sender rules yet.</p>
            </div>
          ) : rules.map(rule => (
            <div key={rule.id} className="py-3 flex items-center gap-3" data-testid={`sender-rule-${rule.id}`}>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold break-all">{rule.sender_email}</p>
                <p className="text-xs text-muted-foreground">Future messages skip Needs Action</p>
              </div>
              <Button size="icon" variant="ghost" className="h-8 w-8 text-[#A3503B]" onClick={() => onRemove(rule)} aria-label={`Remove rule for ${rule.sender_email}`} data-testid={`remove-sender-rule-${rule.id}`}>
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button className="rounded-full" onClick={() => onOpenChange(false)} data-testid="close-sender-rules-button">Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}